// extracted by mini-css-extract-plugin
export default {"dontMiss":"DontMiss_dontMiss__Kzz7F","content":"DontMiss_content__R6UNC","title":"DontMiss_title__5BZRz","text":"DontMiss_text__6IBtA","btn":"DontMiss_btn__jqxEX"};